import React, { Fragment } from 'react';
import { array } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';

const Detail = styled.p`
  color: #999;
  font-size: 12px;
  padding: 5px 24px;
  display: flex;
  line-height: 1.3;
  @media(min-width: 1000px){
    padding: 16px 5px 0 5px;
  }
`;

const Observations = ({ details = [] }) => (
  <Fragment>
    {details.map(detail => (<Detail key={shortid.generate()}>{detail}</Detail>))}
  </Fragment>
);

Observations.propTypes = {
  details: array,
};

Observations.defaultProps = {
  details: [],
};

export default Observations;
